module.exports = __webpack_public_path__ + "img/icon-design.ed1b5500.svg";